import React from 'react';
import ReactDOM from 'react-dom';
import { IsDocumentDefined } from '../is-document/is-document';

const DefaultWrapper = ({ children }) => <span>{children}</span>;

export const RenderCustomComponent = (Wrapper = DefaultWrapper, Child, id) => {
  setTimeout(() => {
    if (IsDocumentDefined()) {
      const elementId = document.getElementById(id);
      if (elementId) ReactDOM.render(<Wrapper>{Child}</Wrapper>, elementId);
    }
  }, 100);
};
